import { AppSidebar } from "@/components/app-sidebar";
import { SiteHeader } from "@/components/site-header";
import SiteLoadingIndicator from "@/components/site-loading-indicator";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { HeaderButtonProvider } from "@/contexts/header-button-context";
import { Icon } from "@elaniintc/goes-design-system";
import { Suspense } from "react";
import { Outlet } from "react-router";

const AdminPanelLayout = () => {
  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "240px",
          "--header-height": "60px",
        } as React.CSSProperties
      }
    >
      <SiteLoadingIndicator />
      <AppSidebar variant="inset" />
      <HeaderButtonProvider>
        <SidebarInset>
          <SiteHeader />
          {/* max-w-[var(--size-horizontal-3xl)] mx-auto */}
          <div className="h-full py-2 px-4 tablet:px-4 laptop:px-6 desktop:px-8 overflow-x-auto w-full has-[.no-portal-padding]:p-0!">
            {/* Boundary for the route components loaded with React.lazy. */}
            <Suspense
              fallback={
                <div className="flex h-full w-full items-center justify-center py-10 text-on-disabled">
                  <Icon
                    type="far"
                    name="spinner-third"
                    className="animate-spin text-xl text-current"
                  />
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </div>
        </SidebarInset>
      </HeaderButtonProvider>
    </SidebarProvider>
  );
};

export default AdminPanelLayout;
